import React from 'react';
import c from 'classnames';

import { useNodeStatesContext, useReactNodeView } from '@lyearn/lygo-core';

const TabPanelComponentReadOnly: React.FC<React.PropsWithChildren> = (props) => {
  const { node, view, getPos } = useReactNodeView();
  const { getNodeState } = useNodeStatesContext();

  if (!node || !getNodeState || !view) {
    return null;
  }

  const parentId =
    typeof getPos === 'function' && getPos()
      ? view.state.doc.resolve(getPos()!).parent.attrs.id
      : null;

  const isActive = parentId ? getNodeState(parentId)?.activeTabId === node.attrs.id : null;

  return <div className={c('p-24', { hidden: !isActive })}>{props.children}</div>;
};

export default TabPanelComponentReadOnly;
